import React from 'react';
import { Form, ErrorMessage } from 'formik';
import { movingTab, width100 } from "../../settings/otherStyles";
import TextField from "@material-ui/core/TextField";
import Select from 'react-select';
// import gql from 'graphql-tag'; // TODO: Removed in favor of REST API
// import { useQuery } from '@apollo/client'; // TODO: Replaced with React Query REST hook
import { useChallengeNames } from '../../hooks/useChallengeNames';
import { FormControlLabel, Radio, RadioGroup, Box, Typography } from '@material-ui/core';
import Team from '../Team/Team';
import TeamSettings from '../Team/TeamSettings';
import Button from "@material-ui/core/Button";
import useAppStore from "../../store/appStore";
import { RolesTypes } from "../../constants/roles";
import UserGroupVisibleSections from './UserGroupVisibleSections';
// TODO: GET_CHALLENGE_DEFINITION_NAMES replaced with REST hook useChallengeNames
/*
const GET_CHALLENGE_DEFINITION_NAMES = gql`
query challengeDefinitionNames {
  challengeDefinitionNames{
    id
    name
  }
}
`;
*/

const UserGroupForm = (props) => {
  const nameText = 'User Group Name (required)';
  const [isCareerPath, setIsCareerPath] = React.useState('false');
  const [openCreateTeam, setOpenCreateTeam] = React.useState(false);
   const user = useAppStore.getState().user.me;
  const handleChange = (event) => {
    setIsCareerPath(event.target.value);
    props.setFieldValue("isCareerPath",event.target.value)
  };

  const handleOpenCreateTeam = () => {
    setOpenCreateTeam(true);
  };

  const handleCloseCreateTeam = () => {
    setOpenCreateTeam(false);
  };
  
  const { data, isLoading: loading, error } = useChallengeNames('published');
  const { values } = props;
  
  if(loading) return null;
  if(error) return null;
  
  // Proceed with rendering if data is available
  return (
      <Form>
        <style>
      {`
        .user-group-form-input-group {
          padding: 0;
        }
        @media (max-width: 768px) {
          .user-group-form-input-group {
            padding: 0.625rem; /* 10px */
          }
        }
      `}
    </style>
        <div className="card-header text-center">
          <h3 className="card-title">
            User Group
          </h3>
        </div>
        <div className="wizard-navigation">
          <div className="moving-tab" style={movingTab}>
            Info
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-6 ml-auto mr-auto">
            <div className="input-group form-control-lg user-group-form-input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="material-icons">face</i>
                </span>
              </div>
              <div className="form-group bmd-form-group">
                <TextField
                  required
                  label={nameText}
                  name="name"
                  value={values.name}
                  onChange={props.handleChange}
                  disabled={user.userRole !== RolesTypes.SUPERUSER}
                  margin="normal"
                  style={width100}
                />
                <ErrorMessage name="name" component="div" />
              </div>

              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="material-icons">fact_check</i>
                </span>
              </div>
              <div className="form-group bmd-form-group">
                {/* <label>Challenges: </label> */}
                <Select
                  name="groupChallenges"
                  placeholder="Select Challenges"
                  options={data?.challengeDefinitionNames?.map((item) => ({ value: item.id, label: item.challengeTitle })) || []}
                  onChange={(values) => props.setFieldValue("groupChallenges", values.map((item) => item.value.toString()))}
                  isMulti={true}
                  isDisabled={user.userRole !== RolesTypes.SUPERUSER && user.userRole !== RolesTypes.COACH}
                  defaultValue={props.groupChallengesSelect}
                  padding={20}
                />
              </div>
              {!props.isCareerPath && props.teams && props.teams.map((item, index) => (
                <Team key={index} item={item} index={index} userGroupId={props.userGroupId} />
              ))}
              {!props.isCareerPath && props.userGroupId &&  (
                <div className="form-group bmd-form-group" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleOpenCreateTeam}
                    startIcon={<i className="material-icons">add</i>}
                  >
                    Add Team
                  </Button>
                </div>
              )}
              <Box display="flex" flexDirection="column">
              {user && (user.userRole === RolesTypes.SUPERUSER || user.userRole === RolesTypes.COACH) && values.menu && (
                <UserGroupVisibleSections menu={values.menu} onChange={(nextMenu) => props.setFieldValue('menu', nextMenu)}></UserGroupVisibleSections>
              )}
              {user && user.userRole === RolesTypes.SUPERUSER && (
                <>
              <div className="input-group-prepend">
                Career Path:
              </div>
              <Box display="flex" alignItems="center" mb={1}>  
              <Typography style={{ minWidth: 160 }}>Is Public Career:</Typography>
              <RadioGroup row aria-label="isCareerPath" name="isCareerPath" value={values.isCareerPath.toString()} onChange={handleChange}>
                <FormControlLabel value="true" control={<Radio />} label="true" />
                <FormControlLabel value="false" control={<Radio />} label="false" />
              </RadioGroup>
              </Box>
              </>
              )}
              </Box>
              <div className="container">

              </div>
              <div className="form-group bmd-form-group ml-auto mr-auto">
                <button type="submit"
                  className="btn btn-next btn-fill btn-rose btn-wd" name="save" value="save">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
        
        {/* TeamSettings dialog for creating new team */}
        {props.userGroupId && (
          <TeamSettings 
            open={openCreateTeam} 
            handleClose={handleCloseCreateTeam}
            userGroupId={props.userGroupId}
            isCreate={true}
          />
        )}
      </Form>
    )
}

export default UserGroupForm;
